/**
* Default config
* @type {Object}
*/
//import {ColumnFilter} from "./column_filter"

export const defaultConfig = {
    classes: {
        button: "datatable-column-filter-button",
        menu: "datatable-column-filter-menu",
        container: "datatable-column-filter-container",
        wrapper: "datatable-column-filter-wrapper"
    },
    labels: {
        button: "Filter columns within the table" // The filter button title
    },
    hiddenColumns: []
}
